import * as React from 'react';
import { Show, SimpleShowLayout, TextField, useShowContext } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { WrappedWithBackButton } from '../common/wrapped-with-back-button';
import { useTheme } from '@mui/material/styles';

export const DocumentShowLayout = () => {
    const { error, isLoading, record } = useShowContext();
    const theme = useTheme();

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>Error!</div>;
    }
    return (
        <SimpleShowLayout>
            <TextField source="id" label={'ID'} sortable={false} />
            <TextField source="name" label={'Név'} sortable={false} />
            {/*<FunctionField
                label="Típus"
                render={(record: any) => `${getDocumentTypeName(record.type)}`}
            />*/}
            {record && record.hasOwnProperty('url') && (
                <Box sx={{ marginBottom: '10px' }}>
                    <Typography sx={{ fontSize: 12 }}>Fájl</Typography>
                    <a
                        href={record.url}
                        target={'_blank'}
                        style={{
                            color:
                                theme.palette.mode === 'dark'
                                    ? theme.palette.primary['400']
                                    : theme.palette.primary.main,
                        }}
                    >
                        {record.url}
                    </a>
                </Box>
            )}
        </SimpleShowLayout>
    );
};
export const DocumentShow = () => {
    return (
        <WrappedWithBackButton>
            <Show title={'Nyomtatvány'}>
                <DocumentShowLayout />
            </Show>
        </WrappedWithBackButton>
    );
};
